<script lang="ts">
	import type { Snippet } from 'svelte';
	import { resolveAny } from '$lib/shared/lib';

	interface Props {
		href: string;
		selected?: boolean;
		onclose?: () => void;
		lead?: Snippet;
	}

	let { href, selected = false, onclose = () => {}, lead }: Props = $props();
</script>

<a
	href={resolveAny(href)}
	class="block px-3 py-1.5 transition-colors hover:text-primary-500 dark:hover:text-primary-500 {selected
		? 'bg-surface-50-800 text-primary-500'
		: ''}"
	onclick={onclose}
>
	{@render lead?.()}
</a>
